// „Сума за отчитане:" на хартията на отчета.
//
// Стойността е `amount_to_report` от BE (в брой + разходи от кешовия бакшиш −
// картовия бакшиш за приспадане), а при по-старо BE — `cash_amount`. Отчет
// без бакшиш показва ТОЧНО досегашното число и същия маркъп (един ред).
//
// Отрицателна стойност НЕ се ограничава до 0: под нея излиза изричен ред
// „Доплащане към персонала: X" — картовият дял на персонала е по-голям от
// парите в брой за предаване.

import { useTranslation } from "react-i18next";

import {
  amountToReportOf,
  staffTopUpOf,
  type ReportWithTips,
} from "../../../../../lib/reportTips";

type Props = {
  report: Pick<ReportWithTips, "amount_to_report" | "cash_amount">;
};

export const ReportAmountToReport = ({ report }: Props) => {
  const { t } = useTranslation();
  const amount = amountToReportOf(report);
  const staffTopUp = staffTopUpOf(amount);

  return (
    <>
      <div className="flex justify-between">
        <span className="font-semibold">{t("personalReport.amountToReport")}</span>
        <span className="font-bold">{Number(amount).toFixed(2)}</span>
      </div>
      {staffTopUp !== null ? (
        <div className="flex justify-between font-bold" data-testid="staff-top-up">
          <span>{t("reportTips.staffTopUp")}</span>
          <span>{staffTopUp.toFixed(2)}</span>
        </div>
      ) : null}
    </>
  );
};
